import { Note } from "@lib/types/Note";
import { StyledNoteCard, StyledNoteTag, StyledNoteTags } from "./index.styled";
import { useIntl } from "react-intl";

type Props = {
  note: Note;
  index: number;
  handleSelect: (note: Note) => void;
};

export default function NoteItem({ note, index, handleSelect }: Props) {
  const { messages } = useIntl();

  const tags = [];
  if (note?.customer) tags.push(note.customer.name);
  if (note?.invoice) tags.push(messages["common.invoice"] as string);
  if (note?.product) tags.push(messages["common.product"] as string);

  return (
    <StyledNoteCard key={note.id || index} onClick={() => handleSelect(note)}>
      <div className="note-content">
        {note.text && note.text.length > 100
          ? `${note.text.substring(0, 100)}...`
          : note.text}
      </div>
      <div className="note-date">
        {new Date(note.updatedAt || note.createdAt).toLocaleDateString()}
      </div>
      <StyledNoteTags>
        {tags.map((tag) => (
          <StyledNoteTag key={tag}>{tag}</StyledNoteTag>
        ))}
      </StyledNoteTags>
    </StyledNoteCard>
  );
}
